import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { registrationData } from '../data/registrationData';

const PricingTable = ({ nationality, conferenceType }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const prices = registrationData[nationality][conferenceType].onsite;
  const currency = nationality === 'indian' ? 'INR' : 'USD';
  
  // Format the conference type for display
  const formattedConferenceType = conferenceType === 'mainConference' 
    ? 'Main Conference (5th & 6th April, 2025)' 
    : 'Full Conference (4th to 6th April, 2025)';

  return (
    <Box sx={{ mb: 3 }}>
      <Typography 
        variant="h6" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold', 
          color: 'primary.main',
          mb: 2
        }}
      >
        Registration Fees
      </Typography>
      
      <Typography 
        variant="subtitle2" 
        gutterBottom 
        sx={{ 
          mb: 2,
          color: 'text.secondary'
        }}
      >
        {nationality === 'indian' ? 'Indian' : 'International'} Delegates - {formattedConferenceType}
      </Typography>
      
      <TableContainer 
        component={Paper} 
        elevation={2}
        sx={{ 
          borderRadius: 2,
          overflow: 'hidden',
          '& .MuiTableCell-root': {
            py: 1.5
          }
        }}
      >
        <Table aria-label="pricing table">
          <TableHead>
            <TableRow sx={{ bgcolor: 'primary.main' }}>
              <TableCell 
                sx={{ 
                  color: 'white', 
                  fontWeight: 'bold',
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                Delegate Type
              </TableCell>
              <TableCell 
                align="right" 
                sx={{ 
                  color: 'white', 
                  fontWeight: 'bold',
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                Fee ({currency})
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(prices).map(([type, price]) => (
              <TableRow 
                key={type}
                sx={{ 
                  '&:nth-of-type(odd)': { 
                    bgcolor: 'action.hover' 
                  },
                  '&:last-child td, &:last-child th': { 
                    border: 0 
                  }
                }}
              >
                <TableCell 
                  component="th" 
                  scope="row"
                  sx={{ 
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    fontWeight: 'medium'
                  }}
                >
                  {type}
                </TableCell>
                <TableCell 
                  align="right"
                  sx={{ 
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    fontWeight: 'bold'
                  }}
                >
                  {price.toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PricingTable; 